import { RegistrationsListView } from './Components/RegistrationsListView';

export default function RegistrationPage() {
  return <RegistrationsListView />;
}